import { FC } from 'react';
import { useHistory, useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import { Box } from '@chakra-ui/react';

import useCompanyContext from 'common/hooks/useCompanyContext';
import BackButton from 'components/BackButton';
import ErrorView from 'components/ErrorView';
import Loader from 'components/Loader';
import { SupportedFeaturePreview } from 'features/Upgrade/types';
import * as ContentLayout from 'layouts/ContentLayout';

import Carousel from './components/Carousel';
import { CAROUSEL_ITEMS } from './features';
import { FeaturePreviewPageDocument } from './graphql/featurePreviewPage.gql';
import locales from './locales';

interface RouteParams {
  featureName: SupportedFeaturePreview;
}

const FeaturePreview: FC = () => {
  const history = useHistory();
  const { companyProfileId = '' } = useCompanyContext();
  const { featureName } = useParams<RouteParams>();

  const { data, error, loading } = useQuery(FeaturePreviewPageDocument, {
    variables: {
      companyProfileId,
      feature: featureName,
    },
  });

  if (error) {
    return <ErrorView />;
  }

  if (loading || !data) {
    return <Loader />;
  }

  const onCallToActionClick = () => {
    history.push({
      pathname: '/upgrade/choice',
      state: { featurePreview: featureName },
    });
  };

  return (
    <ContentLayout.Root>
      <ContentLayout.Body>
        <Box marginBottom="space-24">
          <BackButton />
        </Box>
        <Carousel
          callToActionLabel={locales.callToActionLabel}
          items={CAROUSEL_ITEMS[featureName]({
            higherPlans:
              data.viewer.company.currentPlan
                .upgradablePlansWithFeatureAvailable,
          })}
          onCallToActionClick={onCallToActionClick}
        />
      </ContentLayout.Body>
    </ContentLayout.Root>
  );
};

export default FeaturePreview;
